import { Box, Button, Grid, TextField, Typography, InputAdornment, SvgIcon } from '@mui/material';
import { SearchIcon } from '../../Icons';
import NiveauClasseSelect from '../NiveauClasseSelect';
import GroupsSelect from '../GroupsSelect';

const UserListToolbar = ({
    handleOpenCUUserModal, handleOpenCSVImportModal, updateSearch,
    classroomOptions, classroomsState, setClassroomsState,
    groupsState, setGroupsState,
    ...props
}) => (
    <Box {...props}>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
            <Button color="primary" variant="contained" onClick={handleOpenCUUserModal}>Ajouter</Button>
            <Button color="primary" variant="contained" onClick={handleOpenCSVImportModal}>Importer</Button>
        </Box>
        <Box pb={4}>
            <Grid container spacing={2} alignItems="flex-start">
                <Grid item xs={12} sm={6}>
                    <Typography variant="subtitle2" sx={{ mb: 1 }}>Eleve</Typography>
                    <TextField
                        size="small"
                        fullWidth
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SvgIcon fontSize="small" color="action"><SearchIcon /></SvgIcon>
                                </InputAdornment>
                            )
                        }}
                        placeholder="Rechercher un élève"
                        variant="outlined"
                        onChange={updateSearch}
                    />
                </Grid>
                <Grid item xs={12} sm={6} />
                <Grid item xs={12} sm={6}>
                    <Typography variant="subtitle2" sx={{ mb: 1 }}>Niveau / classe</Typography>
                    <NiveauClasseSelect
                        classroomOptions={classroomOptions}
                        classroomsState={classroomsState}
                        setClassroomsState={setClassroomsState}/>
                    <GroupsSelect groupsState={groupsState} setGroupsState={setGroupsState} />
                </Grid>
            </Grid>
        </Box>
    </Box>
);

export default UserListToolbar;
